import io from "socket.io-client";
import logger from "./LoggerFrontend";

const MEDIA_GENERATOR_URL =
  process.env.MEDIA_TEMPLATE_GENERATION_URL || "wss://talentbait-video-generation.herokuapp.com";
// const MEDIA_GENERATOR_URL = "ws://localhost:8000";

class SocketAPIUtils {
  constructor() {}
  async generateMedia(inputs) {
    logger.debug("SocketAPIUtils:generateMedia", "called", { inputs });
    const imageTemplates = inputs.filter(({ type }) => type == "image");
    const videoTemplates = inputs.filter(({ type }) => type == "video");
    const imageResults = [];
    const videoResults = [];
    await Promise.all([
      (async () => {
        for (const templateData of imageTemplates) {
          imageResults.push(await this.generateImage(templateData));
        }
      })(),
      (async () => {
        for (const templateData of videoTemplates) {
          videoResults.push(await this.generateVideo(templateData));
        }
      })()
    ]);
    return {
      imageResults,
      videoResults
    };
  }
  generateVideo({ inputProps, templateId }) {
    return new Promise((resolve, reject) => {
      this.mediaGenerationSocket = io(MEDIA_GENERATOR_URL, {
        auth: {
          token: "fJFB1gB0cFkleKOMyUP5WbPcPa1VtqLs"
        },
        extraHeaders: {
          "Access-Control-Allow-Origin": "*"
        },
        autoConnect: true,
        withCredentials: false
      });

      logger.log("SocketAPIUtils:generateVideo", "called", {
        inputProps,
        templateId,
        socket: this.mediaGenerationSocket
      });

      this.mediaGenerationSocket.once("videogen:success", ({ url }) => {
        logger.log("MediaGenerationSocket:generateVideo", "videogen:success", {
          url
        });
        resolve({ url });
      });

      this.mediaGenerationSocket.once("videogen:error", ({ error }) => {
        logger.log("error:MediaGenerationSocket:generateVideo", "videogen:error", {
          error
        });
        reject(new Error(error));
      });

      this.mediaGenerationSocket.once("error", (err) => {
        logger.log("error:MediaGenerationSocket", "An error was sent", { err });
        reject(err);
      });

      this.mediaGenerationSocket.emit("render:video", { ...inputProps, templateId });
    });
  }

  generateImage({ inputProps, templateId }) {
    return new Promise((resolve, reject) => {
      logger.log("SocketAPIUtils:generateImage", "called", {
        inputProps,
        templateId,
        socket: this.mediaGenerationSocket
      });
      this.mediaGenerationSocket = io(MEDIA_GENERATOR_URL, {
        auth: {
          token: "fJFB1gB0cFkleKOMyUP5WbPcPa1VtqLs"
        },
        extraHeaders: {
          "Access-Control-Allow-Origin": "*"
        },
        autoConnect: true,
        withCredentials: false
      });
      this.mediaGenerationSocket.once("imagegen:success", ({ url }) => {
        logger.log("MediaGenerationSocket:generateImage", "imagegen:success", {
          url
        });
        resolve({ url });
      });
      this.mediaGenerationSocket.once("imagegen:error", ({ error }) => {
        logger.log("error:MediaGenerationSocket:generateImage", "imagegen:error", {
          error
        });
        reject(new Error(error));
      });
      this.mediaGenerationSocket.once("error", (err) => {
        logger.log("error:MediaGenerationSocket", "An error was sent", { err });
        reject(err);
      });
      this.mediaGenerationSocket.emit("render:image", { inputProps, templateId });
    });
  }
}

const instance = new SocketAPIUtils();

export default instance;
